import React from 'react'
import { Chip } from 'lune-ui-lib'
import { SxProps } from '@mui/material'
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined'

const ForLowCode = ({ sx }: { sx?: SxProps }) => {
    return (
        <Chip
            sx={{ ...sx, maxWidth: 'max-content' }}
            label={'Low / No code'}
            icon={<CodeOutlinedIcon />}
        />
    )
}

export default ForLowCode
